const Menu =  [
    { header: 'Sys Admin' },
    {
        path    : '/',
        title   : 'Dashboard',    
        name    : 'dashboard',  
        icon    : 'dashboard', 
        meta    : {breadcrumb:false}
    }, 
    {      
        title: 'Administrasi',         
        group: 'calon',
        icon : 'account_box',        
        items: [
            { title : 'Pendaftar' },            
            { title : 'Rekap', name:'rekap' }, 
            { title : 'Tes Quran', name:'quran' }, 
        ]
    },   
    {      
        title: 'Keuangan',         
        group: 'signup',
        icon : 'monetization_on',        
        items: [
            { title : 'Daftar Signup' },            
            { title : 'Administrasi', name:'calon' },
            { title : 'Membayar', name:'calon/payment' },
        ]
    },
    {
      path    : '/ruangan',
      title   : 'Ruang Ujian',    
      name    : 'ruangan',  
      icon    : 'view_module', 
      meta    : {breadcrumb:true}
    }, 
    {
        title: 'Input Hasil Tes',         
        group: 'tes',
        icon : 'local_library',        
        items: [            
            { title : 'Kelengkapan', name: 'kelengkapan' },            
            { title : 'Rapor', name: 'rapor' },
            { title : 'Al-quran', name: 'quran' },                                
            { title : 'Ujian Tulis', name: 'ujian' },
            { title : 'Wawancara', name: 'survey' },
        ]
    },
    {
        title: 'Kelulusan',         
        group: 'kelulusan',
        icon : 'spellcheck',        
        items: [            
            { title : 'Sidang', name: 'sidang' },            
            { title : 'Umumkan', name: 'umumkan' },
            //{ title : 'Hasil Keseluruhan', name: 'hasil' },           
        ]
    },
    {
        title: 'Master & Area',         
        group: 'adm',
        icon : 'public',        
        items: [                      
            { title : 'Quetionnaire', name: 'quetionnaire'},
            //{ title : 'Questionnaire', name: 'questionnaire'},
            { title : 'Gedung & Ruang', name: 'gedung', meta : {breadcrumb:false}},
            /*{ title : 'Provinsi', name: 'provinsi'},
            { title : 'Kota/Kab', name : 'kota' },
            { title : 'Kecamatan', name: 'kecamatan' },            
            { title : 'Kelurahan', name: 'kelurahan' },*/                                  
        ]
    },      
    {
        title   : 'RBAC Auth',
        group   : 'rbac',
        icon    : 'pets',                    
        items: [
            {title: 'Users', name: 'user', meta : {breadcrumb:false}},
            {title: 'Assignment', name: 'assignment'},            
            {title: 'Roles', name: 'roles'},
            {title: 'Permissions', name: 'permissions'},            
            {title: 'Routes', name: 'routes'},
            
        ]
    },
    {
        path    : '/settings',
        title   : 'Settings',    
        name    : 'settings',  
        icon    : 'settings_applications', 
        meta    : {breadcrumb:true}
    },
    
    
    //NON MENU
    { group: 'dashboard',
      visible: false,
      items:[
        { title : 'Explore', name: 'explore', meta:{breadcrumbs:false} },
        { title : 'Live', name: 'live', meta:{breadcrumbs:false, public:true} },
      ]
    },   
    { group: 'profile',
      visible: false,
      items:[
        { title : 'Profile', meta:{breadcrumbs:false} },
        { title : 'Update Profile', name: 'form' },        
      ]
    },
    {
        group: 'tes',
        visible: false,
        items: [            
            { title : 'Wawancara', name: 'survey' },
            { title : 'List Wawancara', name: 'survey/respon' },
            { title : 'Rekap Wawancara', name: 'survey/respon/rekap' },
            { title : 'Ujian To Excel', name: 'ujian_excel' },
            { title : 'Ujian View', name: 'ujian_view' },
            { title : 'Rapor To Excel', name: 'rapor_excel' },
            { title : 'Form Wawancara', name: 'survey/respon/form', meta:{breadcrumbs:false} },
        ]
    },
    {
        group: 'adm',
        visible : false,
        items: [
            { title : 'Wawancara', name: 'quetionnaire/form'},
            { title : 'Questionnaire', name: 'questionnaire/form'},
            { title : 'Soal', name: 'quetionnaire/view'},
            { title : 'Mata Pelajaran', name: 'matpel/form'},
            /*{ title : 'Provinsi', name: 'provinsi/form'},
            { title : 'Kota/Kab', name: 'kota/form' },
            { title : 'Kecamatan', name: 'kecamatan/form' },            
            { title : 'Kelurahan', name: 'kelurahan/form' }, */           
        ]
    },        
    { group: 'calon',
      visible: false,
      items:[
        { title : 'calon Form', name: 'form' },
        { title : 'calon View', name: 'view' }, 
        { title : 'kartu Ujian', name: 'card' }, 
      ]
    },
    { group: 'signup',
      visible: false,
      items:[
        { title : 'Signup Form', name: 'form' },
        { title : 'Calon Form', name: 'calon/form' }, 
        { title : 'Calon Form', name: 'calon/view' }, 
        { title : 'Payment', name: 'calon/payment' },        
        { title : 'Payment Form', name: 'calon/payment/form' },        
        { title : 'Payment View', name: 'calon/payment/view' }, 
        { title : 'Payment Rekap', name: 'calon/payment/excel' },        
      ]
    },
    { group: 'user',
      visible: false,
      items:[
        { title : 'Calon', name: 'form' },        
      ]
    }, 
    { group: 'settings',
      visible: false,
      items:[
        { title : 'Setting Form', name: 'form' },        
      ]
    }, 
    {
        title   : 'Auth',
        group   : 'rbac',
        visible: false,                   
        items: [            
            {title: 'User', name:'user/form'},
            {title: 'Permissions', name: 'permissions/form'},
            {title: 'Permissions', name: 'permissions/view'},
            {title: 'Roles', name: 'roles/form'},
            {title: 'Roles', name: 'roles/view'},
            {title: 'Assignment', name: 'assignment/view'}            
        ]
    },
];

import Remenu from '@/util/remenu';
export default Remenu(Menu);
